type ListingAddressFields = {
  address?: ApiAddress;
  latitude?: number;
  longitude?: number;
};

export type ListingMapsInfo = {
  lines: string[];
  label: string | null;
  mapsUrl: string | null;
};

export function getListingMapsInfo(listing: ListingAddressFields): ListingMapsInfo {
  const street = listing.address?.street?.trim();
  const cityState = [listing.address?.city, listing.address?.state]
    .filter((part) => part && String(part).trim().length > 0)
    .join(", ");
  const cityPostal = [cityState, listing.address?.postal_code]
    .filter((part) => part && String(part).trim().length > 0)
    .join(" ");
  const localityLine = [cityPostal, listing.address?.country]
    .filter((part) => part && String(part).trim().length > 0)
    .join(", ");
  const lines = [street, localityLine].filter(
    (part): part is string => Boolean(part && String(part).trim().length > 0),
  );
  const label = lines.length > 0 ? lines.join(", ") : null;

  if (
    listing.latitude != null &&
    listing.longitude != null &&
    !Number.isNaN(Number(listing.latitude)) &&
    !Number.isNaN(Number(listing.longitude))
  ) {
    return {
      lines,
      label,
      mapsUrl: `https://www.google.com/maps/search/?api=1&query=${listing.latitude},${listing.longitude}`,
    };
  }

  if (label) {
    return {
      lines,
      label,
      mapsUrl: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(label)}`,
    };
  }

  return { lines, label, mapsUrl: null };
}
